export const leagues = [
  'yle',
  'pro',
  'frm',
];
